import { gradeConstants } from '../../constants';
import { gradeService } from '../../services';
import { notificationActions } from './notification.actions';

const getAll = () => {
  return async (dispatch: any) => {
    const request = () => ({ type: gradeConstants.GETALL_REQUEST });
    const success = (grades: any) => ({ type: gradeConstants.GETALL_SUCCESS, payload: grades });
    const failure = (error: any) => ({ type: gradeConstants.GETALL_FAILURE, payload: error });

    try {
      const grades = await gradeService.getAll();
      dispatch(success(grades));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };
};

const createGrade = (formData: any) => {
  return async (dispatch: any) => {
    dispatch(request(formData));

    try {
      const grade = await gradeService.create(formData);
      dispatch(success(grade));
      dispatch(notificationActions.addNotification('Tạo grade thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request(grade: any) {
    return { type: gradeConstants.CREATE_REQUEST, payload: grade };
  }
  function success(grade: any) {
    return { type: gradeConstants.CREATE_SUCCESS, payload: grade };
  }
  function failure(error: any) {
    return { type: gradeConstants.CREATE_FAILURE, error };
  }
};

const deleteGrade = (gradeId: any) => {
  return async (dispatch: any) => {
    dispatch(request(gradeId));

    try {
      await gradeService.remove(gradeId);
      dispatch(success(gradeId));
      dispatch(notificationActions.addNotification('Xóa grade thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request(gradeId: number) {
    return { type: gradeConstants.DELETE_REQUEST, payload: gradeId };
  }
  function success(gradeId: number) {
    return { type: gradeConstants.DELETE_SUCCESS, payload: gradeId };
  }
  function failure(error: any) {
    return { type: gradeConstants.DELETE_FAILURE, error };
  }
};

const updateGrade = (formData: any) => {
  return async (dispatch: any) => {
    dispatch(request(formData));

    try {
      const updatedGrade = await gradeService.update(formData);
      dispatch(success(updatedGrade));
      dispatch(notificationActions.addNotification('Cập nhật grade thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request(grade: any) {
    return { type: gradeConstants.UPDATE_REQUEST, payload: grade };
  }
  function success(grade: any) {
    return { type: gradeConstants.UPDATE_SUCCESS, payload: grade };
  }
  function failure(error: any) {
    return { type: gradeConstants.UPDATE_FAILURE, error };
  }
};

export const gradeActions = {
  getAll,
  createGrade,
  updateGrade,
  deleteGrade
};
